export * from "./generated-image";
